/**
 * @file
 * A JavaScript file containing the carousel functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.carousel = {
    attach: function (context) {
      $(document).ready(function () {
        $(".tiny-slider", context)
          .once("carousel-processed")
          .addClass("carousel-processed")
          .each(function () {
            var options = $(this).data("carousel");
            var itemSizeSmall = {
              0: { edgePadding: 0, gutter: 10, items: 1 },
              450: { edgePadding: 15, gutter: 16 },
              900: { edgePadding: 23, gutter: 24, items: 2 },
              1150: { items: 3 },
            };
            var itemSizeBig = {
              0: { gutter: 10, items: 1 },
              600: { gutter: 16, items: 2 },
              900: { items: 3 },
              1250: { items: 4 },
            };
            var itemSizeSideInfo = {
              0: { items: 1 },
              1000: { items: 2 },
              1350: { items: 3 },
            };

            var itemSizeLanguageMenu = {
              0: { items: 2.25 },
              900: { items: 3.75 },
              1100: { items: 4.5 },
              1350: { items: 5.25 },
            };

            var itemSizeNone = {
              0: {},
            };

            var itemSize = itemSizeSmall;
            if (options.itemSize == "none") {
              itemSize = itemSizeNone;
            } else if (options.itemSize == "big") {
              itemSize = itemSizeBig;
            } else if (options.itemSize == "side-info") {
              itemSize = itemSizeSideInfo;
            } else if (options.itemSize == "language-menu") {
              itemSize = itemSizeLanguageMenu;
              console.log("this one");
            }

            tns({
              nav: options.nav,
              loop: options.loop,
              controlsText: options.controlsText,
              container: this,
              autoWidth: options.autoWidth,
              autoplay: false,
              mouseDrag: true,
              gutter: options.gutter,
              edgePadding: 0,
              slideBy: options.slideBy,
              arrowKeys: false,
              items: options.items,
              responsive: itemSize,
            });
            if (
              $(this).closest(".carousel").hasClass("carousel--anchor-link")
            ) {
              $(".carousel-anchor-link__item").each(function () {
                if ($(this).attr("href") == window.location.pathname) {
                  $(this).addClass("isActive");
                  return;
                }
              });
              $(document).on(
                "click",
                ".carousel-anchor-link__item",
                function () {
                  var $this = $(this);
                  $this.addClass("isActive").siblings().removeClass("isActive");
                }
              );
            }
          });
      });
    },
  };
})(Drupal, jQuery);
